import React, { useEffect, useState } from 'react';
import { getMessaging, getToken } from "firebase/messaging";
import { SERVICE_WORKER } from '..';
import { Button, IconButton, Tooltip } from '@chakra-ui/react';
import { useWSysHub, WSysHeaderButton } from '@coimbra-its/websys-ux-core';
import { APPICONS } from '../Icons';
import { useKonyveloApi } from '../store/konyvelo.api';
import { useWSysAuthSlice } from '../store/authSlice';
import { MdNotificationAdd, MdNotificationsActive, MdNotificationsOff } from 'react-icons/md';


// Get registration token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.

export interface PushNotificationButtonProps {
	subject: string;
}


export function PushNotificationButton({ subject }: PushNotificationButtonProps) {

	const api = useKonyveloApi();
	const authSlice = useWSysAuthSlice();
	const hub = useWSysHub();
	const isSubscribed = !!authSlice.notificationSubscriptions.find(sub => sub.SUBJECT === subject);

	const notificationSubscribePost = api.notificationSubscribePost.useAction();
	const notificationSubscribeDelete = api.notificationSubscribeDelete.useAction();
	const notificationTestPost = api.notificationTestPost.useAction();


	// ez nem biztos h.kell, lehet elég a myGetToken()
	const requestPermission = () => {
		console.log('Requesting permission...');
		Notification.requestPermission().then((permission) => {
			if (permission === 'granted') {
				console.log('Notification permission granted.', permission);
			}
		});
	}

	const myGetToken = async () => {
		if (!SERVICE_WORKER.registration)
			return alert('no registration');;


		hub.tryCatch(async () => {
			const messaging = getMessaging();
			const token = await getToken(messaging, { vapidKey: "BGzFUPJVABhjZPIC6oyI4EquKUagtYdFlR9SOgypmSRCaUUS5iTyPp27ogPch5aGgpQDJCduTtX7qhA_CcjRNF0", serviceWorkerRegistration: SERVICE_WORKER.registration });
			console.log('getToken()', token);
			const ret = await notificationSubscribePost({ token, subject, deviceId: authSlice.deviceId });
			authSlice.setNotificationSubscriptions(ret.notification_subscriptions || []);
			hub.addEvent({ message: ret.message, severity: 'success' });
		});
	}

	const test = () => {
		hub.tryCatch(async () => {
			const ret = await notificationTestPost({});
			hub.addEvent({ message: ret.message, severity: 'success' });
		})
	}

	const doUnsubscribe = () => {
		hub.tryCatch(async () => {
			const ret = await notificationSubscribeDelete({ deviceId: authSlice.deviceId, subject: subject });
			authSlice.setNotificationSubscriptions(ret.notification_subscriptions || []);
			hub.addEvent({ message: ret.message, severity: 'success' });
		})
	}

	const [isHover1, setIsHover1] = useState(false);
	const [isHover2, setIsHover2] = useState(false);

	return (<>
		{/*<Button onClick={() => requestPermission()} colorScheme='primary' size='xs' >req</Button>
		<Button onClick={() => test()} colorScheme='primary' size='xs' >test</Button>*/}
		{!isSubscribed
			? <IconButton aria-label='értesítések' isLoading={hub.isLoading}
				onMouseEnter={() => setIsHover1(true)} onMouseLeave={() => setIsHover1(false)}
				icon={isHover1 ? <MdNotificationAdd /> : <MdNotificationsOff />}
				onClick={() => myGetToken()} size='sm' 
				title='Értesítések bekapcsolása'
				></IconButton>

			: <IconButton aria-label='értesítések' isLoading={hub.isLoading}
				onMouseEnter={() => setIsHover2(true)} onMouseLeave={() => setIsHover2(false)}
				icon={isHover2 ? <MdNotificationsOff /> : <MdNotificationsActive />}
				onClick={() => doUnsubscribe()} colorScheme='blue' size='sm'
				title='Értesítések kikapcsolása'
			></IconButton>

		}
	</>);
};

